import { create } from 'zustand'
import { clearAdminToken } from '@/api/adminApi'
import { sessionApi, type User } from '@/api/sessionApi'
import { ApiError } from '@/api/http'

type AuthStatus = 'unknown' | 'authed' | 'guest' | 'error'

interface AuthState {
  user: User | null
  status: AuthStatus
  /** 启动时调用: 用 cookie 恢复登录态 */
  bootstrap: (signal?: AbortSignal) => Promise<void>
  login: (username: string, password: string, captcha?: string, captchaSalt?: string) => Promise<void>
  logout: () => Promise<void>
  clearSession: () => void
}

export const useAuthStore = create<AuthState>((set) => ({
  user: null,
  status: 'unknown',

  bootstrap: async (signal) => {
    try {
      const user = await sessionApi.me(signal)
      set({ user, status: 'authed' })
    } catch (err) {
      if (err instanceof Error && err.name === 'AbortError') return
      // 401 = 未登录 (正常); 其它错误保留为服务异常, 避免把已登录用户误踢到登录页。
      if (err instanceof ApiError && err.status === 401) {
        set({ user: null, status: 'guest' })
      } else {
        console.warn('Auth bootstrap failed', err)
        set({ user: null, status: 'error' })
      }
    }
  },

  login: async (username, password, captcha, captchaSalt) => {
    const user = await sessionApi.login(username, password, captcha, captchaSalt)
    set({ user, status: 'authed' })
  },

  logout: async () => {
    try {
      await sessionApi.logout()
    } finally {
      clearAdminToken()
      set({ user: null, status: 'guest' })
    }
  },

  clearSession: () => {
    set({ user: null, status: 'guest' })
  },
}))
